import BenchmarkTemplates from "./benchmark-templates";

export default BenchmarkTemplates;